var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525C69",
    d: "M10,13 L10,10 L12,10 L12,2 L2,2 L2,10 L4,10 L4,13 L1.70000005,13 C0.761115947,13 -1.07064464e-16,12.2388841 -2.22044605e-16,11.3 L-2.22044605e-16,1.70000005 C-3.37024746e-16,0.761115947 0.761115947,-2.95815068e-14 1.70000005,-2.97539771e-14 L12.3,-2.95319325e-14 C13.2388841,-2.88705061e-14 14,0.761115947 14,1.70000005 L14,11.3 C14,12.2388841 13.2388841,13 12.3,13 L10,13 Z M6.00870612,7.92000351 L3.10110152,7.92000351 L7.00847103,4.3678494 L10.9158405,7.92000351 L8.02731135,7.92000351 L8.02731135,12.8931369 L6.00870612,12.8931369 L6.00870612,7.92000351 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f077af02f4089239f3b472bc44195d93.svg";
export { ForwardRef as ReactComponent };